module.exports = __webpack_public_path__ + "img/logo.0a5a935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 663
// module chunks = 0 2 14